import type { I18nUtilities } from '@change-corgi/core-react/i18n';

import type { ShareAction } from '#src/app/shared/hooks/share';

import type { Channel } from './types';

type TranslateLabel = (i18n: I18nUtilities) => string;

type ChannelButtonConfig = {
	label: TranslateLabel;
	successLabel?: TranslateLabel;
	secondaryLabel?: TranslateLabel;
};

const SHARE_BUTTON_CONFIG: Readonly<Record<Channel, ChannelButtonConfig>> = {
	facebook: { label: (i18n) => i18n.translate('fe.components.psf.share.buttons.short.facebook') },
	twitter: { label: (i18n) => i18n.translate('fe.components.psf.share.buttons.short.twitter') },
	whatsapp: { label: (i18n) => i18n.translate('fe.components.psf.share.buttons.short.whatsapp') },
	email: { label: (i18n) => i18n.translate('fe.components.psf.share.buttons.short.email') },
	sms: { label: (i18n) => i18n.translate('fe.components.psf.share.buttons.short.sms') },
	copy: {
		label: (i18n) => i18n.translate('fe.components.psf.share.buttons.copy_link'),
		successLabel: (i18n) => i18n.translate('fe.components.share_buttons.copied'),
	},
	mobileNativeShare: { label: (i18n) => i18n.translate('corgi.psf.share.buttons.short.mobile_share') },
	instagramStories: { label: (i18n) => i18n.translate('corgi.psf.share.buttons.short.instagram_stories') },
	instagram: { label: (i18n) => i18n.translate('fe.components.psf.share.buttons.short.instagram') },
	facebookMessenger: { label: (i18n) => i18n.translate('fe.components.psf.share.buttons.short.facebook_messenger') },
	line: { label: (i18n) => i18n.translate('fe.components.psf.share.buttons.short.line') },
	nextdoor: { label: (i18n) => i18n.translate('corgi.psf.share.buttons.short.nextdoor') },
	reddit: { label: (i18n) => i18n.translate('corgi.psf.share.buttons.short.reddit') },
	tiktok: { label: (i18n) => i18n.translate('corgi.psf.share.buttons.short.tiktok') },
	vk: {
		label: (i18n) => i18n.translate('fe.components.petition_share.accordion.share_on_network', { socialNetwork: 'VK' }),
	},
};

type Result = ReadonlyArray<
	Pick<ShareAction, 'ShareAction' | 'channel' | 'url'> & {
		label: TranslateLabel;
		successLabel?: TranslateLabel;
	}
>;

export function mapButtonConfigs(shareActions: readonly ShareAction[]): Result {
	return shareActions.map(({ ShareAction, channel, url }) => ({
		ShareAction,
		channel,
		url,
		...SHARE_BUTTON_CONFIG[channel],
	}));
}
